export default {
  setPermission(state, { data }) {
    state.permission = data;
  },
  profile(state, {admin, imach, maintainer, vm}) {
    state.admin = admin
    state.imach = imach
    state.maintainer = maintainer
    state.vm = vm
  },
  show(state, { data }) {
    state.group = data;
  },
  set(state, { data }) {
    state.groups = data;
  },
  setPerm(state, { data }) {
    state.listPerm = data;
  },
  setUser(state, { data }) {
    state.listUser = data;
  },
  setCompExpire(state, { data }) {
    state.compExpire = data;
  },
  setCompSoldOut(state, { data }) {
    state.compSoldOut = data;
  },
  setFlag(state, { data }) {
    state.flag = data;
  },

}